export default {
  // SEO
  'about.seo.title': 'Who Are Andrew & Tristan Tate? | Tate Protest',
  'about.seo.description': 'An overview of Andrew and Tristan Tate — their backgrounds, the legal proceedings in Romania, the United Kingdom, and the United States, and the questions raised by supporters about due process and fair treatment.',

  // Hero
  'about.hero.title': 'Who Are Andrew & Tristan Tate?',
  'about.hero.subtitle': 'An overview of the people, the legal proceedings, and the evidence surrounding one of the most controversial international criminal investigations in recent history.',

  // Profile cards
  'about.andrew.title': 'Andrew Tate',
  'about.andrew.body': 'Andrew Tate is a British-American entrepreneur, former four-time kickboxing world champion, and online personality. After retiring from professional sports, he built several businesses and became one of the most recognizable figures on social media.',
  'about.tristan.title': 'Tristan Tate',
  'about.tristan.body': 'Tristan Tate is a British-American entrepreneur and former professional kickboxer. He has partnered with Andrew Tate across multiple business ventures and frequently appears in interviews discussing business, culture, and current events.',
  'about.learnMore': 'Learn More',

  // Legal proceedings
  'about.legal.title': 'The Legal Proceedings',
  'about.legal.romania': 'Romania',
  'about.legal.uk': 'United Kingdom',
  'about.legal.us': 'United States',
  'about.legal.ro.arrest': 'Arrest',
  'about.legal.ro.indictment': 'Indictment',
  'about.legal.ro.appeals': 'Appeals',
  'about.legal.currentStatus': 'Current Status',
  'about.legal.uk.charges': 'Criminal Charges',
  'about.legal.uk.extradition': 'Extradition Request',
  'about.legal.us.arrest': 'Florida Arrest',
  'about.legal.us.federal': 'Federal Proceedings',
  'about.legal.explore': 'Explore Timeline',

  // Questions raised
  'about.questions.title': 'Questions Raised by Supporters',
  'about.questions.body': 'Supporters argue that the investigations have raised questions regarding due process, prolonged legal proceedings, disclosure of evidence, media coverage, and political motivations. Critics dispute those claims and maintain that the allegations should be addressed through the courts. This website documents publicly available information so readers can examine the material and reach their own conclusions.',
  'about.questions.viewEvidence': 'View Evidence',

  // Founder
  'about.founder.label': 'Founded by',
  'about.founder.name': 'Wil Pujols',
  'about.founder.before': 'Florida entrepreneur and cousin of MLB legend',
  'about.founder.name2': 'Albert Pujols',
  'about.founder.after': '. Wil launched Tate Protest to bring attention to the ongoing legal proceedings and advocate for due process, transparency, and the fair treatment of Andrew and Tristan Tate.',
  'about.founder.learnMore': 'Learn more about Wil',

  // Statistics
  'about.stats.title': 'The Case by the Numbers',
  'about.stats.yearsLabel': 'Years Under Investigation',
  'about.stats.yearsSubtitle': '2015 to present',
  'about.stats.countries': 'Countries Involved',
  'about.stats.hearings': 'Court Hearings',
  'about.stats.proceedings': 'Legal Proceedings',

  // CTA
  'about.cta.title': 'Every Voice Matters',
  'about.cta.body': 'Join thousands of people around the world standing up for due process and human rights. The Tate brothers deserve a fair and transparent legal process.',
  'about.cta.faq': 'Read the FAQ',
  'about.cta.getInvolved': 'Get Involved',
};